import React from 'react';
import SmallContainer from './SmallContainer';
import { fmt } from '../../utils/fmtUtils';

const TablaGenerales = props => {
  const zona15 = ["880030515","880035515","880038015"]
  const withOutExtra = zona15.includes(props.data.data.amb);
  let PmesasCorregido = "0";
  const Idconsultas = ['6', '8', '9'];
  console.log(props.data.elec);
  if(withOutExtra  && !Idconsultas.includes(props.data.data.elec)){
    PmesasCorregido = (Math.floor((props.data.data.totales.act.mesesc)/(parseInt(props.data.data.totales.act.metota)+6) *10000 )/100 +"%").replace('.', ',');
  } else if (withOutExtra && Idconsultas.includes(props.data.data.elec)) {
    PmesasCorregido = (Math.floor((parseInt(props.data.data.totales.act.mesesc) + 6)/(parseInt(props.data.data.totales.act.metota)+6) *10000 )/100 +"%").replace('.', ',');
  } else {
    PmesasCorregido = props.data.data.totales.act.pmesesc;
  }
  return (
    <div className="datosGenerales">
      <div className="container content">
        {/* <div className="smallContainer1"> */}
          <SmallContainer
            value={fmt(withOutExtra && Idconsultas.includes(props.data.data.elec) ? parseInt(props.data.data.totales.act.mesesc)+6 : props.data.data.totales.act.mesesc)}
            text={'MESAS INFORMADAS'}
            percent={PmesasCorregido}
          />
        {/* </div>
        <div className="smallContainer2"> */}
          <SmallContainer
            value={fmt(props.data.data.totales.act.votant)}
            text={'VOTANTES'}
            percent={props.data.data.totales.act.pvotant}
          />
        {/* </div> */}
        {/* <SmallContainer
          value={fmt(props.data.data.totales.act.votnma)}
          text={'Tarjetas no marcadas'}
          percent={props.data.data.totales.act.pvotnma}
        />
        <SmallContainer
          value={fmt(props.data.data.totales.act.votnul)}
          text={'Votos Nulos'}
          percent={props.data.data.totales.act.pvotnul}
        /> */}
      </div>
    </div>
  );
};

export default TablaGenerales;
